const axios = require('axios')

export default class Profile {
    getProfile(id) {
        return axios.get(`/profile/${id}`)
    }

    changePassword(id, data) {
        return axios.post(`/profile/${id}/changePassword`, data)
    }

    update(id, data) {
        return axios.patch(`/profile/${id}`, data)
    }

    signature(id, data) {
        return axios.post(`/profile/${id}/signature`, data)
    }
}